const CLAW_BASE_URL = 'https://jinri-claw.xhey.top'
const XOR_KEY = 'claw'

interface ClawUrlParams {
  groupId: string
  plan: number
  planName: string
}

function encode(str: string): string {
  const bytes = new TextEncoder().encode(str)
  const keyBytes = new TextEncoder().encode(XOR_KEY)
  return Array.from(bytes)
    .map((b, i) =>
      (b ^ keyBytes[i % keyBytes.length]).toString(16).padStart(2, '0')
    )
    .join('')
}

export function buildClawUrl(params: ClawUrlParams): string {
  const { groupId, plan, planName } = params
  const ref = encode(JSON.stringify({ g: groupId, p: plan, n: planName }))
  return `${CLAW_BASE_URL}/?claw_ref=${ref}`
}
